export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-move@4x-ff376ffc07d175c08c8e215d2d1b79a7.webp";